import { useQueries } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export default function useProcessingAttachments({ attachments, onProcessed }) {
  const processingAttachmentHashids = attachments
    .filter((attachment) => attachment.attributes.attachedProcessed === false)
    .map((attachment) => attachment.attributes.hashid);

  useQueries({
    queries: processingAttachmentHashids.map((hashid) => ({
      queryKey: ['attachment', hashid],
      queryFn: async () => {
        const response = await axios.get(`/attachments/${hashid}`);
        return response.data;
      },
      select: (data) => formatData({ data, resourceTypes: ['coverImage'] }),
      refetchInterval: (data) =>
        data?.data?.attributes?.attachedProcessed ? false : 2000,
      retry: false,
      onSuccess: ({ data, included }) => {
        if (!data.attributes.attachedProcessed) return;

        onProcessed({
          attachment: data,
          coverImages: Object.values(included.coverImage),
        });
      },
    })),
  });
}
